import { VISITS_OF_ADS_OPTION } from 'components/DashboardTab/PlacementAnalytics/constants';
import {
  GA_CHART_ID,
  AD_PERFORMANCE_CHART_ID,
  DAYPART_COMPILATION_CHART_ID,
  ADVISIT_BY_DAY_OF_WEEK_CHART_ID,
  ADTYPE_CHART_ID,
  STATION_CHART_ID,
  ADVISIT_CHART_ID,
  GEO_CHART_ID,
  TRAFFIC_CHANNEL_CHART_ID,
  KEYWORD_CHART_ID,
  PAGE_PATH_CHART_ID,
  DEVICE_CATEGORY_CHART_ID,
} from './constant';

export const TYPE_KEY = 'type';
export const ADTYPE_KEY = 'adType';
export const STATION_TYPE_KEY = 'stationType';
export const DATA_TYPE = 'dataType';

export const defaultChartSelector = {
  [GA_CHART_ID]: {
    [TYPE_KEY]: "visit",
    timeRange: "daily",
    isCompare: false
  },
  [ADVISIT_BY_DAY_OF_WEEK_CHART_ID]: {
    [TYPE_KEY]: 'adVisit/ads',
  },
  [AD_PERFORMANCE_CHART_ID]: {
    [TYPE_KEY]: "visit"
  },
  [DAYPART_COMPILATION_CHART_ID]: {
    [TYPE_KEY]: "adVisit",
    timeRange: "byDayPart",
    showBaseSerie: true,
    showAdditionSerie: true,
    showGuidelineSerie: true
  },
  [ADTYPE_CHART_ID]: {
    [ADTYPE_KEY]: VISITS_OF_ADS_OPTION
  },
  [STATION_CHART_ID] : {
    isShowLabel: true,
    [STATION_TYPE_KEY]: VISITS_OF_ADS_OPTION
  },
  [ADVISIT_CHART_ID]: {
    [DATA_TYPE]: 'visitOfads',
    categoryType: 'creative_name'
  },
  [GEO_CHART_ID]: {
    [TYPE_KEY]: 'visitsOfAds'
  },
  [TRAFFIC_CHANNEL_CHART_ID]: {
    [TYPE_KEY]: 'adVisits'
  },
  [KEYWORD_CHART_ID]: {
    type: 'adVisits'
  },
  [DEVICE_CATEGORY_CHART_ID]: {
    [TYPE_KEY]: 'adVisits'
  },
  [PAGE_PATH_CHART_ID]: {
    [TYPE_KEY]: 'adVisits'
  }
}
export const defaultTableSortStatus = {
  [ADVISIT_CHART_ID]: {
    sortKey: "visitOfAds",
    sortStatus: "desc",
  },
  newAdUsersPerAds: {
    sortKey: "newAdUsersPerAds",
    sortStatus: "desc",
  }
}
